import React from 'react';
import DetailsContent from './DetailsContent';


function DetailsContainer() {


    return (
        <React.StrictMode>
            <div id={"content-container"} >
                <DetailsContent />
            </div>
        </React.StrictMode>
    );

}

export default DetailsContainer;
